import ContributionsList from "components/authors/ContributionsList";
import BookHighlights from "components/BookRow/BookHighlights";
import CoverLink from "components/Cover/CoverLink";
import BookMatchPercentageForUser from "components/match/BookMatchPercentage/BookMatchPercentageForUser";
import { BookSeriesTag } from "components/series/BookSeriesTag";
import { ResizeableBookButton } from "features/BookButton";
import TextLink from "hardcover-ui/components/TextLink";
import {
  BookSerializersBookByline,
  EditionSerializersEditionByline,
} from "types/serializers";

interface Props {
  book: BookSerializersBookByline;
  edition?: EditionSerializersEditionByline;
  size: "sm" | "md" | "lg";
  className?: string;
  children?: React.ReactNode;
  referrerUserId?: number;
  settings?: {
    showInfoClass?: string;
    linkContributions?: boolean;
  };
}

export default function BookRow({
  book,
  edition,
  size = "md",
  className = "",
  referrerUserId,
  children,
  settings = {
    showInfoClass: "",
    linkContributions: false,
  },
}: Props) {
  const coverSize = size === "lg" ? "md" : size === "md" ? "sm" : "xs";

  return (
    <div className={`${className} flex flex-row space-x-2 w-full`}>
      <div className="flex-none">
        <CoverLink
          book={book}
          edition={edition}
          size={coverSize}
          variant="secondary"
          settings={{
            tooltip: true,
            showStatus: true,
            details: true,
          }}
        />
      </div>
      <div className="grow">
        <p className="shrink space-x-2 flex items-baseline">
          <BookSeriesTag
            book={book}
            className="max-w-[260px] sm:max-w-none overflow-hidden text-ellipsis"
          />
          <BookMatchPercentageForUser bookId={book.id} />
        </p>
        <div>
          <TextLink
            href={`/books/${book.slug}`}
            variant="title"
            size="md"
            underline={false}
          >
            {edition ? edition.title : book.title}
          </TextLink>
          <ContributionsList
            contributions={
              edition?.contributions?.length > 0
                ? edition.contributions
                : book.contributions
            }
            link={settings.linkContributions || false}
            size="xs"
            primary
            byLine
          />
        </div>
        <div className="w-full flex flex-row justify-between items-end space-x-2 pr-2">
          {children ? (
            children
          ) : (
            <BookHighlights book={book} edition={edition} />
          )}
          <div className="flex-none">
            <ResizeableBookButton
              bookId={book.id}
              referrerUserId={referrerUserId}
              size="sm"
              sizeLg="md"
              sizeSm="sm"
              placement="bottom-end"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
